import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SouvenirShopIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SouvenirShopIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M5.98445 21.8476C6.0945 21.9577 6.2438 22.0195 6.39952 22.0195H18.1402C18.2959 22.0195 18.4452 21.9577 18.5553 21.8476L20.9034 19.4994C21.0135 19.3893 21.0754 19.24 21.0754 19.0843V8.47857C21.0754 8.15437 20.8125 7.89154 20.4883 7.89154H17.5532V4.91723C17.5532 4.75963 17.4873 4.60837 17.3816 4.50251C17.3814 4.50235 17.3817 4.50263 17.3816 4.50251L15.0331 2.15398C14.923 2.04389 14.7737 1.98206 14.618 1.98206H9.92173C9.76601 1.98206 9.61671 2.04389 9.50666 2.15398C9.50666 2.15398 7.15833 4.50235 7.15817 4.50247C7.04988 4.61095 6.98656 4.76264 6.98656 4.91723V7.89154H4.05139C3.72719 7.89154 3.46436 8.15438 3.46436 8.47857V19.0843C3.46436 19.24 3.52619 19.3893 3.63632 19.4994L5.98445 21.8476ZM15.205 7.89154V5.50427H16.3791V7.89154H15.205ZM10.5088 7.89154V5.50427H14.031V7.89154H10.5088ZM10.1649 3.15613H14.3749L15.5489 4.3302H8.99082L10.1649 3.15613ZM8.16063 5.50427H9.3347V7.89154H8.16063V5.50427ZM4.63842 9.06561H19.9013V18.8412L17.8971 20.8454H6.64267L4.63842 18.8412V9.06561Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.74766 17.3232C8.42346 17.3232 8.16063 17.5861 8.16063 17.9103C8.16063 18.2344 8.42347 18.4973 8.74766 18.4973H15.7921C16.1163 18.4973 16.3791 18.2344 16.3791 17.9103C16.3791 17.5861 16.1163 17.3232 15.7921 17.3232H15.205V14.936H15.7921C16.0508 14.936 16.2789 14.7666 16.3539 14.519C16.4288 14.2715 16.3329 14.004 16.1177 13.8605L12.5955 11.5124C12.3983 11.3809 12.1414 11.3809 11.9442 11.5124L8.422 13.8605C8.20675 14.004 8.11083 14.2715 8.18578 14.519C8.2608 14.7666 8.48896 14.936 8.74765 14.936H9.33468V17.3232H8.74766ZM14.031 17.3232H12.8569V14.936H14.031V17.3232ZM12.2699 12.7063L13.8532 13.7619H10.6865L12.2699 12.7063ZM10.5088 14.9359H11.6828V17.3232H10.5088V14.9359Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SouvenirShopIcon;
